module.exports = __webpack_public_path__ + "static/hyperv_52.60ec65b8.png";